export const SelectionTeamActionType =
	{
		SET_SELECTED_TEAMS: "SET_SELECTED_TEAMS",
	};
